
import request from 'axios'
// import config from '../../config'

request.interceptors.request.use(
    (config) => {
        if (process.env.NODE_ENV !== 'development') {
            return config
        }
        const { headers } = config
        if (!headers.apptoken) {
            headers.apptoken = 'bcARqH6Vy0Ew98LV5MDk7TBdFVDZgYtQBCVlhjASLVsGnNJ81nsil74tsxqLu4YlpiXbtwzfyLLhFK49OT2njA=='
        }
        if (!headers.ticket) {
            headers.ticket = 'toBXk86zhHjVPTqEUYZX3rAeTiGuTOFBCmfvdqf7IHaHR2cDv7Id4sHyY8_eJUV62CJnapP0fzD1qj4FmOqumtMwtKh9pl998jU9EM1VCKmAe3qDP_1_kBW5qU3apXnVoJnRGYlsrdy5YPcVIvjWIA=='
        }
        /*if (!headers.ticket) {
            headers.ticket = 'toBXk86zhHjVPTqEUYZX3rAeTiGuTOFBCmfvdqf7IHaHR2cDv7Id4sHyY8_eJUV62CJnapP0fzD1qj4FmOqumtPzEOvFbxsvw0maGldh7GPVNhf_O2N-Y1B3NReRUzZ4mYcJRVI6_2BJTx7K82B29A=='
        }*/
        return config
    },
    (err) => {
        return Promise.reject(err)
    }
)

request.interceptors.response.use(
    async (response) => {
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default request
